import { Link, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import { authActions, filterActions } from "_store";
import React from "react";
import "../Home/Home.css";

export { AdminSidebar };

function AdminSidebar() {

  const auth = useSelector((x) => x.auth.value);
  const filter = useSelector((x) => x.filter);
  const [menuOpen, setMenuOpen] = useState(false);
  const menuToggle = () => {
    setMenuOpen(!menuOpen);
  };


  // only show nav when logged in
  if (!auth) return null;
  const dispatch = useDispatch();
  const logout = () => dispatch(authActions.logout());

  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  const location = useLocation();
  // console.log(location?.pathname?.split('/')[1]);

  useEffect(() => {
    if (Object.keys(filter.filterOptions).length === 0) {
      dispatch(filterActions.getFilterOptions());
    }
  }, []);

  useEffect(() => {
    const url1 = location?.pathname?.split("/")[1];
    switch (url1) {
      case "vendor":
        setActiveTab("tab1");
        break;
      case "product-catalog":
        setActiveTab("tab2");
        break;
      case "app":
        setActiveTab("tab3");
        break;
      case "rtv":
        setActiveTab("tab4");
        break;
      case "document-center":
        setActiveTab("tab5");
        break;
    }
  }, [location?.pathname]);

  return (
    <aside className="all-page-sidebar d-flex">
      <div className={`main-sidebar d-flex align-center relative flex-col ${menuOpen ? "sidebar-open" : ""}`}>
        <div className="sidebar-logo-sec relative d-flex align-center justify-between">
          <div className={`sidebar-logo d-flex align-center ${menuOpen ? "w-80" : ""}`}>
            <Link to="/admin-home/">
              <div className={`s-logo-icon relative ${menuOpen ? "w-80" : ""}`}>
                {!menuOpen && <img src="/images/LogoSmall.svg" alt="" />}
                {menuOpen && <img src="/images/Logo.svg" alt="" />}
              </div>
            </Link>
          </div>
          <div className="m-sidebar-close-btn relative align-center justify-center" onClick={menuToggle}>
            <img src="/images/menu-close-icon.svg" alt="" />
          </div>
        </div>
        <div className="sidebar-open-btn align-center justify-center" onClick={menuToggle}>
          <img src="/images/line-arrow.svg" alt="" />
        </div>
        <div className="sidebar-menu-sec relative">
          <ul className="relative d-flex flex-col">
            <li className={`relative ${activeTab === "tab1" ? "active-menu" : ""}`}>
              <Link to="/admin-user-list" className="relative d-flex align-center justify-start">
                <span className="s-menu-img d-flex align-center justify-center">
                  <img src="/images/account-box-icon.svg" alt="" />
                </span>
                <span className="s-menu-text relative d-flex align-center">
                  Users
                </span>
              </Link>
            </li>
            {/* <li className={`relative ${activeTab === "tab2" ? "active-menu" : ""}`}>
              <Link to="/product-catalog" className="relative d-flex align-center justify-start">
                <span className="s-menu-img d-flex align-center justify-center">
                  <img src="/images/amp-stories-icon.svg" alt="" />
                </span>
                <span className="s-menu-text relative d-flex align-center">
                  Role
                </span>
              </Link>
            </li> */}
          </ul>
        </div>
        <div className="footer-sb-menu sidebar-menu-sec">
          <ul className="relative d-flex flex-col">
            <li className="relative">
              <Link onClick={logout} className="relative d-flex align-center justify-start" >
                <span className="material-symbols-outlined s-menu-img d-flex align-center justify-center">
                  {" "}
                  exit_to_app{" "}
                </span>{" "}
                <span className="s-menu-text relative d-flex align-center">
                  Logout
                </span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </aside>
  );
}